const refs = {
  btnToMapForm: document.querySelector('[data-back-to-map-form]'),
  btnBackToCars: document.querySelector('[data-back-to-cars-choice]'),

  sectionMapForm: document.querySelector('.map-form'),
  sectionCars: document.querySelector('.content-box'),
  sectionPayment: document.querySelector('.payment'),
};

const {
  btnToMapForm,
  btnBackToCars,

  sectionMapForm,
  sectionCars,
  sectionPayment,
} = refs;

function handlerClickBtnToMapForm() {
  if (sectionPayment) sectionPayment.style.display = 'none';
  if (sectionMapForm) sectionMapForm.style.display = 'flex';

  sectionMapForm?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
}

function handlerClickBtnToCars() {
  if (sectionPayment) sectionPayment.style.display = 'none';
  if (sectionCars) sectionCars.style.display = 'flex';

  sectionCars?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
}
// Прив'язуємо слухачі лише якщо є кнопки та цільові секції
if (btnToMapForm && sectionMapForm && sectionPayment) {
  if (!btnToMapForm.dataset.listenerAttached) {
    btnToMapForm.addEventListener('click', handlerClickBtnToMapForm);
    btnToMapForm.dataset.listenerAttached = 'true';
  }
}

if (btnBackToCars && sectionCars && sectionPayment) {
  if (!btnBackToCars.dataset.listenerAttached) {
    btnBackToCars.addEventListener('click', handlerClickBtnToCars);
    btnBackToCars.dataset.listenerAttached = 'true';
  }
}
